import Seo from "src/components/shared/Seo";
import server from "src/api/server";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

const OurworksPage = dynamic(() =>
  import("src/modules/OurworksPage/OurworksPage")
);

export default function Ourworks({
  data,

  metaData = [],
  appSetting = {},
  footerSettings,
}) {
  const router = useRouter();
  const { locale } = router;

  const customMeta = [
    { name: "title", content: metaData?.[0]?.name?.[locale] },
    {
      name: "description",
      content: metaData?.[0]?.content?.[locale],
    },
  ];

  return (
    <>
      <Seo
        metaData={customMeta}
        appSetting={{
          ...appSetting,
          ...footerSettings,
        }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}/${router.asPath}`
        }
      />

      <OurworksPage data={data} />
    </>
  );
}

export async function getStaticProps() {
  try {
    const [galleryRes, indexRes, metaRes, questionsRes, footerRes] =
      await Promise.all([
        server.get("/api/posts/our_works/all"),
        server.get("/api/index"),
        server.get("/api/metadataTags?type=ourWorks"),
        server.get("/api/posts/questions_works/all"),
        server.get("/api/footer"),
      ]);

    const appSetting = indexRes?.data?.data?.AppSetting;

    return {
      props: {
        data: {
          galleryData: galleryRes?.data?.data || null,
          questions: questionsRes?.data?.data || null,
        },
        metaData: metaRes?.data?.data?.metadata_tags || null,
        appSetting: appSetting || null,
        footerSettings: footerRes?.data?.data || null,
      },
      revalidate: 60,
    };
  } catch (error) {
    return {
      props: {
        data: {
          galleryData: null,
          questions: null,
        },
        metaData: null,
        appSetting: null,
        footerSettings: null,
      },
      revalidate: 60,
    };
  }
}
